var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('users-or-invites-table',{attrs:{"data":_vm.data,"space":_vm.selectedSpace},on:{"actionTaken":function($event){return _vm.loadData()}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }